import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from '../locales/en/translations.json';
import noTranslations from '../locales/no/translations.json';

/**
 * The site is Norwegian only for now. Set to true to bring back the
 * language dropdown in the header and browser language detection.
 */
export const LANGUAGE_SWITCHING_ENABLED = false;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: LANGUAGE_SWITCHING_ENABLED ? undefined : 'no',
    fallbackLng: 'no',
    supportedLngs: ['en', 'no'],

    detection: {
      lookupLocalStorage: 'i18nextLng',
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      convertDetectedLanguage: (lng) => {
        if (lng.startsWith('no')) return 'no';
        if (lng.startsWith('en')) return 'en';
        return 'no';
      },
    },

    resources: {
      en: {
        translation: enTranslations,
      },
      no: {
        translation: noTranslations,
      },
    },

    interpolation: {
      escapeValue: false,
    },

    debug: false,
  });

export default i18n;
